import { render } from "./PasswordChangeView.vue?vue&type=template&id=db99c0f6"
import script from "./PasswordChangeView.vue?vue&type=script&lang=js"
export * from "./PasswordChangeView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__